export enum MenuItemType {
  internalWeb = "internalWeb",
  externalWeb = "externalWeb",
  htmlContent = "htmlContent",
  nativeModule = "nativeModule",
}
